import { render, staticRenderFns } from "./check.vue?vue&type=template&id=a4313fe0&scoped=true&"
import script from "./check.vue?vue&type=script&lang=js&"
export * from "./check.vue?vue&type=script&lang=js&"
import style0 from "./check.vue?vue&type=style&index=0&id=a4313fe0&prod&lang=less&"
import style1 from "./check.vue?vue&type=style&index=1&id=a4313fe0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4313fe0",
  null
  
)

export default component.exports